import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class ProductSet extends CatalogObjectSerializer {
  serialize(snapshot, options = {}) {
    const json = super.serialize(snapshot, options);
    const {
      id,
      product_set_data,
      type,
      version
    } = json;
    return {
      id,
      product_set_data,
      type,
      version
    };
  }
}